import { useSelector } from "react-redux";
import { createStyles, Grid, rem } from "@mantine/core";
import { SignDocumentStatus } from "./SignDocumentStatus";
import PdfLabel from "./PdfLabel";

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: `#f5f5f5`,
    padding: `20px 5px 5px 5px`,
    borderRadius: `4px`,
  },
  showuserback: {
    padding: `4px 0px`,
    marginBottom: `4px`,
  },
  nogaptop: {
    padding: 0,
    marginTop: `-6px`,
  },
  textsize: {
    fontSize: rem("12px"),
    marginTop: `4px`,
    [theme.fn.smallerThan("lg")]: {
      fontSize: rem("10px"),
    },
  },
}));

type DocumentSignMode = {
  resourceId: string;
  signMode: string;
};

const ShowStapelDocSiganturen = (props: { documentsSignModes: DocumentSignMode[] }) => {
  const { classes } = useStyles();
  const initdocs = useSelector((state: any) => state.user.meetingdocs);

  const resourceIdSet = new Set(props.documentsSignModes.map((d) => d.resourceId));
  const stapelDocs = (initdocs || []).filter((doc: any) => resourceIdSet.has(doc.resourceId));

  return (
    <div className={classes.container}>
      {stapelDocs.map((item: any, index: number) => (
        <div key={item.resourceId} className={classes.showuserback}>
          <Grid>
            <Grid.Col span={2} className={classes.nogaptop}>
              <SignDocumentStatus resourceId={item.resourceId} />
            </Grid.Col>
            <Grid.Col span={10} className={classes.nogaptop}>
              <PdfLabel
                isPDFA1b={item.isPDFA1b}
                signatureCount={item.signatureCount}
                resourceId={item.resourceId}
                convert={false}
                viewcount={false}
              />
              <div className={classes.textsize}>{item.name}</div>
            </Grid.Col>
          </Grid>
          {index < stapelDocs.length - 1 && <hr />}
        </div>
      ))}
    </div>
  );
};

export default ShowStapelDocSiganturen;
